/**
 * tokenStorage.js
 *
 * Thin wrapper around localStorage for auth tokens.
 * All token reads/writes go through here — no raw localStorage calls elsewhere.
 *
 * FIX: JSON.parse wrapped in try/catch to handle corrupted storage values.
 * FIX: setAccessToken exported so axiosInstance can use it after refresh.
 */

const KEYS = {
  ACCESS_TOKEN:  "access_token",
  REFRESH_TOKEN: "refresh_token",
  USER:          "user",
  ACTIVE_TENANT: "activeTenant",
};

// ── Getters ───────────────────────────────────────────────────────────────────
export const getAccessToken  = () => localStorage.getItem(KEYS.ACCESS_TOKEN);
export const getRefreshToken = () => localStorage.getItem(KEYS.REFRESH_TOKEN);

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(KEYS.USER));
  } catch {
    return null;
  }
};

export const getActiveTenant = () => {
  try {
    const raw = localStorage.getItem(KEYS.ACTIVE_TENANT);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

// ── Setters ───────────────────────────────────────────────────────────────────
export const setAccessToken  = (token)  => localStorage.setItem(KEYS.ACCESS_TOKEN, token);
export const setRefreshToken = (token)  => localStorage.setItem(KEYS.REFRESH_TOKEN, token);
export const setUser         = (user)   => localStorage.setItem(KEYS.USER, JSON.stringify(user));
export const setActiveTenant = (tenant) => localStorage.setItem(KEYS.ACTIVE_TENANT, JSON.stringify(tenant));

// ── Bulk helpers ──────────────────────────────────────────────────────────────
export const saveSession = ({ access_token, refresh_token, user }) => {
  setAccessToken(access_token);
  setRefreshToken(refresh_token);
  setUser(user);
};

export const clear = () => {
  Object.values(KEYS).forEach((key) => localStorage.removeItem(key));
};